import { render } from "./SendInvoiceByEmail.vue?vue&type=template&id=fe2dfa26"
import script from "./SendInvoiceByEmail.vue?vue&type=script&lang=js"
export * from "./SendInvoiceByEmail.vue?vue&type=script&lang=js"

import exportComponent from "/usr/local/var/www/duo_front/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__